<template>
  <section>

    <!-- Pesticide08模版详情 -->
    <div class="p8__body" v-if="datas.template == 'Pesticide08'">
      <ul>
        <li class="underline" v-if="datas.data.batch">批次号：{{ datas.data.batch.name }}</li>
        <li class="underline" v-if="datas.data.batch && datas.data.batch.qc" v-for="(item, index) in datas.data.batch.qc"
          :key="index">
          <p class="label">{{ item.key }}：{{ item.value }}</p>
        </li>
        <li>产品介绍：{{ datas.data.product.introduce }}</li>
        <li v-for="(item, index) in datas.data.product.attribute" :key="index">
          <img v-if="item.value.includes('png') || item.value.includes('jpg')" :src="item.value">
          <div v-else class="label">
            <span class="key">{{ item.key }}：</span>{{ item.value }}
          </div>
        </li>
      </ul>
    </div>

    <!-- AntiFake09模版详情 -->
    <div class="a9__body" v-else-if="datas.template == 'AntiFake09'">

      <!-- 防伪验证 -->
      <div v-if="datas.type == '防伪验证'">
        <div class="swiper-container banner">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="datas.data.focus && datas.data.focus_pics_is_show == 1" v-for="(item,index) in datas.data.focus" v-bind:key="index"><img :src="item.img"></div>
          </div>
          <div class="swiper-pagination"></div>
        </div>

        <div class="input__box">
          <span class="label">防伪码：</span>
          <input v-model="datas.data.verify" placeholder="请输入防伪码或扫描二维码" type="number" @keyup.enter="CodeVerify" />
        </div>
        <div class="check__box" @click="CodeVerify">
          <div class="btn">查询</div>

          <!-- 查询结果 -->
          <template v-if="state">
            <div class="return">
              <p v-if="state == 2" class="title ac">验证失败！</p>
              <div v-if="state == 1">
                <p class="title">验证成功！</p>
                <p>恭喜，您查询的产品为我公司生产的正规产品</p>
                <p>产品名称：<span class="ac">{{datas.data.product.name}}</span></p>
                <p>欢迎您的再次光临！</p>
              </div>
            </div>

            <div class="info" v-if="state == 1">
              <ul class="tabs">
                <li v-for="(value, index) in ['产品详情', '全程溯源', '检测报告']" :key="index" @click="tabIndex=index">
                  <a :class="{ac: tabIndex== index}">{{value}}</a>
                </li>    
              </ul>

              <div class="prod__info" v-if="tabIndex == 0">
                <p>{{datas.data.product.name}}</p>
                <ul v-if="datas.data.product.attribute" v-for="val in datas.data.product.attribute">
                  <img v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")' class="img-box" :src="val.value" />
                  <li v-else>{{ val.key }}{{ val.value }}</li>
                </ul>
              </div>

              <div v-if="datas.data.ref && datas.data.ref_is_show == 1" v-for="(item, index) in datas.data.ref" v:key="index">
                <div v-if="item.datas">
                  <div v-if="tabIndex == 1 && ['全程溯源'].includes(item.name)">
                    <div v-for="value in item.datas">
                      <div class="nav" :style="{margin: value.index!=-1?'10px 10px 0 10px':''}" v-if="value.type == 0" @click="value.show=!value.show">{{ value.data }}<img class="arrow" :class="{up:value.show}" src="/static/images/bottom.png" /></div>
                      <img class="img" :style="{padding: value.index!=-1?'0 10px':''}" v-if="value.type == 1 && (value.index == -1 || item.datas[value.index].show)" :src="value.data" />
                    </div>
                  </div>

                  <div v-if="tabIndex == 2 && ['检测报告'].includes(item.name)">
                    <div v-for="value in item.datas">
                      <img class="img" v-if="value.type == 1" :src="value.data" />
                      <p v-else>{{ value.data }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>

      <!-- 自定义栏目 -->
      <div v-if="datas.data.ref && datas.data.ref_is_show == 1" v-for="(item, index) in datas.data.ref" v:key="index">
        <div v-if="datas.type == item.name && item.datas">
          <div v-for="value in item.datas">
            <div class="nav" :style="{margin: value.index!=-1?'10px 10px 0 10px':''}" v-if="value.type == 0" @click="value.show=!value.show">{{ value.data }}<img class="arrow" :class="{up:value.show}" src="/static/images/bottom.png" /></div>
            <img class="img" :style="{padding: value.index!=-1?'0 10px':''}" v-if="value.type == 1 && (value.index == -1 || item.datas[value.index].show)" :src="value.data" />
          </div>
        </div>
      </div>
    </div>


    <!-- Normal25模版详情 -->
    <div class="n25__body" v-else-if="datas.template == 'Normal25'">
      <!-- banner -->
      <template v-if="datas.data.focus && datas.data.focus_pics_is_show == 1" v-for="(item, index) in datas.data.focus">
        <div  class="banner"  v-if="index == 1" :key="index">
            <img :src="item.img">
        </div>
      </template>

      <div class="titNav" :class="`tc${datas.type}`">原厂正品 谨防假冒伪劣</div>

      <!-- 首次 -->
      <div class="first" v-if="datas.type == 1">
        <div class="text">
          <p>验证结果</p>
          <p>该唯一码对应的产品为</p>
        </div>

        <div class="form">
          <ul class="row">
            <li class="label">产品名称：</li>
            <li class="value">{{ datas.data.product.name }}</li>
          </ul>
          <ul class="row" v-if="datas.data.product.attribute" v-for="val in datas.data.product.attribute">
              <li class="label">{{val.key}}：</li>
              <li class="value">{{ val.value }}</li>
            </ul>
        </div>

        <div>
          <div class="text">请核实包装内产品和查询结果是否一致</div>
          <div class="text" style="font-size: 35rem;font-weight: bold;margin-top: 10rem;">感谢您选择士卓曼产品!</div>
          <img class="qr" src="/static/images/Normal25/qr.png">
          <div class="guide">关注您的口腔种植顾问，获取更多资讯</div>
        </div>

      </div>

      <!-- 多次 -->
      <div class="repeat" v-if="datas.type == 2">
        <div class="text themeTwoColor return">验证结果</div>
        <div class="text acColor">此防伪码已经验证过</div>
        <div class="text" style="color: #6BCFA9;">上次验证时间是{{ datas.data.query_first_time }}</div>
        <div class="text contact">
          <p>如有任何问题，请您尽快联系士卓曼工作人员或致电</p>
          <p>士卓曼中国(010-5775 6555)，并请保留二维码和</p>
          <p>产品包装等相关信息。</p>
        </div>
        <div class="qr">
          <img src="/static/images/Normal25/qr1.png" />
        </div>
        <div class="text" style="font-size: 23rem;">关注您的口腔种植顾问，获取更多资讯</div>
      </div>

    </div>

    <!-- 其它详情 -->
    <div v-else>
      <header>
        <div class="header fix">
          <img v-on:click="back(false)" :style="{ left: left, opacity: opaque }" class="header-icon header-icon-left"
            src="/static/images/Normal05/back.svg">
          <a class="header-main" v-text="datas.name"></a>
          <img v-on:click="back(true)" :style="{ right: right, opacity: opaque }" class="header-icon header-icon-right"
            src="/static/images/Normal05/home.svg">
        </div>
      </header>

      <div>
        <div v-if="datas.data && datas.data.length > 0">
          <div class="form-box" v-if="datas.name == '质量诉求'">
            <ul v-for="(item, index) in form" class="list-form">
              <li class="list-form-left" v-text="item.key + '：'"></li>
              <li class="list-form-right" v-if="index != form.length - 1"><input :placeholder="item.key"
                  v-model="item.value" /></li>
              <li class="list-form-right" v-else>
                <textarea :placeholder="item.key" v-model="item.value"></textarea>
              </li>
            </ul>
            <div class="list-form-submit" v-on:click="submit"><a>提交</a></div>
          </div>
          <div class="product-box" v-else-if="datas.name == '商品中心'">
            <ul v-for="(item, index) in productlist" v-on:click="PageJump(index)">
              <li class="product-box-img"><img class="img" :src="item.img"></li>
              <li class="product-box-name" v-text="item.name"></li>
              <div class="product-box-details">
                <a>查看详情</a>
                <img class="product-box-details-icon" src="/static/images/Normal05/right-three.svg">
              </div>
            </ul>
          </div>
          <div class="details-box" v-else>
            <div v-for="item in datas.data">
              <p v-if="item.type == 0" v-text="item.data"></p>
              <p v-if="item.type == 1" class="details-img"><img class="img" :src="item.data"></p>
            </div>
          </div>
        </div>
        <div class="null-box" v-else>
          <div class="null-img"><img src="/static/images/null.png"></div>
          <div class="null-text">内容为空</div>
        </div>
      </div>

      <!-- 提示框 -->
      <section id="MaskedBlock" v-if="hintTxt">
        <i class="Masked"></i>
        <div class="ToolTip">
          <ul>
            <li>{{ business.name }}</li>
            <li class="MaskedMain" v-text="hintTxt"></li>
            <li class="confirm" v-on:click="CloseTip">确定</li>
          </ul>
        </div>
      </section>

    </div>
  </section>
</template>

<script>
var self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'Details',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data() {
    return {
      opaque: 0,
      left: "-50px",
      right: "-50px",
      business: null,
      datas: null,
      hintTxt: null,
      backForm: null,
      form: [{
        key: "所购产品",
        value: null
      }, {
        key: "购买数量",
        value: null
      }, {
        key: "购买日期",
        value: null
      }, {
        key: "购买地址",
        value: null
      }, {
        key: "购买人",
        value: null
      }, {
        key: "联系电话",
        value: null
      }, {
        key: "质量描述",
        value: null
      }],
      productlist: null,
      state: '',
      tabIndex: 0,
    }
  },
  created(options) {
    self = this;
    self.datas = JSON.parse(localStorage.getItem("wwm_ref"));
    self.business = JSON.parse(localStorage.getItem("wwm_business"));
    if (self.datas && self.datas.name == "商品中心") {
      self.GetList();
    }
    if(this.$route.query.template){
      self.datas.type = this.$route.query.type;
      self.datas.template = this.$route.query.template;
    }
    
    try {
      if(this.$route.query.template == 'Normal25'){
        this.AdaptiveSizeNew();
      }
      let code = localStorage.getItem(`wwm_Normal25_${self.datas.data.code}`);
      if(code){
        self.datas.type = code;
      }
    } catch (error) {
      console.log('errr', error)
    }

    self.backForm = JSON.parse(JSON.stringify(self.form));
    $(document).scrollTop(0);

    setTimeout(function () {
      self.opaque = 1;
      self.left = "10px";
      self.right = "10px";
    }, 10)
  },
  mounted() {
    if(this.$route.query.template == 'AntiFake09'){
      new Swiper('.banner',{
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: true,//可选选项，自动滑动
        loop: true, //可选选项，开启循环
      })
    }
  },
  methods: {
    back(state) {
      if (state) {
        this.$router.push({ path: "/Normal05" }); // 模板路由跳转
      } else {
        this.$router.back()
      }
    },
    PageJump(ix) {
      var datas = self.productlist[ix];
      localStorage.setItem("wwm_ProductDetails", JSON.stringify({ name: "商品中心", data: datas }));
      this.$router.push({ path: "/ProductDetails" }); // 模板路由跳转
    },
    CloseTip() {
      self.hintTxt = null;
    },
    GetList() {
      axios({
        method: 'get',
        url: self.GetServerUrl(1) + "production_list2/1/" + self.business.rootid,
      }).then(function (res) {
        var json = res.data;
        if (json.code == 200) {
          self.productlist = json.meta.data;
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    submit() {
      let param = new URLSearchParams()
      param.append('cid', self.business.rootid)
      param.append('body', JSON.stringify(self.form))
      axios({
        method: 'post',
        data: param,
        url: self.GetServerUrl(1) + "feelback",
      }).then(function (res) {
        var json = res.data;
        self.form = JSON.parse(JSON.stringify(self.backForm));
        self.hintTxt = "提交成功，感谢您对我们的支持与反馈！";
      }).catch(function (error) {
        self.hintTxt = "提交失败，请联系管理员！";
      })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.datas.data.code + "/" +  self.datas.data.verify)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.state = 1;
          } else {
            self.state = 2;
          }
        }).catch(function (error) {
          self.state = 2;
        })
    },
  }
}
</script>

<style scoped lang="scss">
.img {
  display: block;
  width: 100%;
  margin-bottom: 8px;
}

.details-box {
  color: #333;
  line-height: 25px;
  font-size: 15px;
}

.details-box p {
  text-indent: 20px;
  margin-bottom: 15px;
}

.details-box {
  padding: 90px 15px 30px 15px;
  background-color: #FFF;
}

.details-img {
  margin-top: 10px;
}

.form-box {
  padding: 70px 15px 30px 15px;
}

header {
  position: relative;
  background-color: #5faf28;
}

.header {
  color: #FFF;
  text-align: center;
  font-size: 19px;
  background-color: #5faf28;
  z-index: 99;
}

.headerTwo {
  margin-top: 10px;
}

.fix {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
}

.header-icon {
  width: 25px;
  position: absolute;
  transition: all .8s ease 0s;
}

.header-icon-left {
  top: 15px;
}

.header-icon-right {
  top: 13px;
}

.header-main {
  padding: 15px 0;
  display: block;
  text-align: center;
  margin-left: 35px;
  width: calc(100% - 70px);
}

.headerOne .header-main,
.headerTwo .header-main {
  width: calc(100% - 30px);
  margin-left: 15px;
}

.null-box {
  padding: 20vh 0;
}

.null-img img {
  width: 160px;
  display: block;
  margin: 0 auto;
}

.null-text {
  color: #777;
  font-size: 17px;
  text-align: center;
}

.list-form {
  overflow: hidden;
}

.list-form li {
  float: left;
  margin-bottom: 15px;
}

.list-form-left {
  width: 90px;
  line-height: 38px;
  font-size: 16px;
}

.list-form-right {
  width: calc(100% - 90px);
}

.list-form-right input {
  height: 38px;
  padding: 0 10px;
  border-radius: 5px;
  font-size: 16px;
  width: calc(100% - 22px);
  background-color: #FFF;
  border: 1px solid #e3e3e3;
}

.list-form-right textarea {
  min-height: 80px;
  line-height: 25px;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 16px;
  width: calc(100% - 22px);
  background-color: #FFF;
  border: 1px solid #e3e3e3;
}

.list-form-submit {
  color: #fff;
  width: 175px;
  font-size: 17px;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
  background: #F7950A;
  margin-left: 90px;
}

.product-box {
  background-color: #FFF;
  padding-top: 55px;
}

.product-box ul {
  padding: 10px;
  overflow: hidden;
  position: relative;
  border-bottom: 1px dashed #ddd;
}

.product-box ul:last-child {
  border: 0;
}

.product-box ul li {
  float: left;
}

.product-box-img {
  width: 80px;
  height: 80px;
}

.product-box-img img {
  height: 100%;
}

.product-box-name {
  padding-left: 20px;
  line-height: 25px;
  font-size: 16px;
  width: calc(100% - 100px);
}

.product-box-details {
  position: absolute;
  right: 12px;
  bottom: 30px;
}

.product-box-details a {
  color: #51B202;
  font-size: 15px;
}

.product-box-details-icon {
  width: 16px;
  position: relative;
  top: 3px;
  padding-left: 5px;
}

.ToolTip ul li:last-child {
  background-color: #5faf28;
}



/* p8 */
.p8__body {
  min-height: 100vh;
  padding-left: 20px;
  background-color: white;

  ul {
    li {
      color: #666;
      font-size: 14px;
      padding: 5px 0;
      position: relative;
      padding-right: 15px;

      .key {
        font-size: 15px;
        font-weight: bold;
      }
    }

    .underline {
      padding: 10px 0;
      border-bottom: 1px solid #bbb;
    }

    .text-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}


.a9__body{
  min-height: 100vh;
  background-color: #fbf4e4;
  img{
    width: 100%;
    display: block;
    box-sizing: border-box;
  }
  .nav{
    font-size: 16px;
    color: white;
    border-radius: 5px;
    margin-top: 10px;
    position: relative;
    padding: 5px 5px 5px 20px;
    background-color: #f28e00;
    .arrow{
      display: block;
      position: absolute;
      width: 16px;
      top: calc(50% - 8px);
      right: 10px;
      transition: all .3s;
    }
    .up{
      transform: rotate(-180deg);
    }
  }

  .input__box{
    padding: 5px 15px;
    margin-top: 10px;
    display: flex;
    gap: 10px;
    align-items: center;
    flex-direction: row;
    background-color: white;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    .label{
      white-space: nowrap;
      font-size: 16px;
      line-height: 30px;
    }
    input{
      height: 30px;
      width: 100%;
      border: none;
      font-size: 16px;
    }
  }
  .check__box{
    padding:20px 15px;
    .btn{
      border-radius: 5px;
      padding: 10px 0;
      text-align: center;
      font-size: 18px;
      color: white;
      background-color: #f08200;
    }
    .return{
      line-height: 22px;
      margin-top: 15px;
      .title{
        font-weight: bold;
      }
      .ac{
        color: rgb(200, 6, 6);
      }
    }

    .info{
      .tabs{
        padding: 0;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 25px;
        margin-bottom: 5px;
        list-style: none;
        border-bottom: 1px solid #DDD;
        li{
          float: left;
          margin: 0 -15px 0 0;
          border-bottom: 0px solid #666;
        }
        a{
          height: 0;
          opacity: .3;
          float: left;
          color: #FFF;
          font-size: 14px;
          padding: 0 10px;
          line-height: 25px;
          position: relative;
          text-decoration: none;
          text-transform: uppercase;
          border-bottom-color: #777;
          border-right: 30px solid transparent;
          border-bottom: 25px solid #3D3D3D;
        }
        .ac{
          z-index: 1;
          border-bottom-color: #3d3d3d;
          opacity: 1;
        }
      }
      .prod__info{
        line-height: 25px;
        display: flex;
        flex-direction: column;
      }
    }
  }
}


.n25__body{
  font-size: 28rem;
  min-height: 100vh;
  background-color: white;
  $themeColor: #8bbd21;
  $themeTwoColor: #008740;
  padding-bottom: 50rem;
  .banner{
    display: flex;
    padding: 40rem 0;
    align-items: center;
    justify-content: center;
    img{
      width: 350rem;
    }
  }

  .titNav{
    color: white;
    padding: 15rem 0;
    text-align: center;
    font-size: 30rem;
  }
  .tc1{
    background-color: $themeColor;
  }
  .tc2{
    background-color: $themeTwoColor;
  }

  .themeTwoColor{
    color: $themeTwoColor;
  }

  //首次查询
  .first{
    .text{
      font-size: 30rem;
      margin-top: 20rem;
      text-align: center;
      color: $themeColor;
      p{
        margin-bottom: 5px;
      }
    }

    .form{
      gap: 15rem;
      padding: 30rem 60rem 0 60rem;
      display: flex;
      flex-direction: column;
      .row{
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .label{
          width: 160rem;
          text-align: justify;
          text-align-last: justify;
        }
        .value{
          margin-left: 10rem;
          width: calc(100% - 170rem);
          word-wrap: break-word;
          word-break: break-all;
          line-height: 45rem;
        }
      }
    }

    .qr{
      display: block;
      width: 200rem;
      margin: 0 auto;
      margin-top: 30rem;
    }
    .guide{
      text-align: center;
      font-size: 24rem;
      margin-top: 20rem;
    }
  }
  

  //多次查询
  .repeat{
    .return{
      font-size: 35rem;
      margin-top: 40rem;
      font-weight: bold;
    }
    .acColor{
      color: #FF0000;
      font-weight: bold;
      font-size: 40rem;
      padding: 20rem 0;
    }
    .text{
      text-align: center;
    }
    .contact{
      color: #0DBE6E;
      padding: 0 80rem;
      margin: 16vh 0 20rem 0;
      text-align: left;
      font-size: 25rem;
      p{
        margin: 5rem 0;
      }
    }
    .qr{
      margin-top: 30rem;
      margin-bottom: 15rem;
      display: flex;
      justify-content: center;
      img{
        width: 200rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/public-view/Details.vue